import Enumerable from 'linq';
import { SORT_CARS_ARRAY } from '../actionsTypes';
import {
  A_Z, CHEAP_FIRST, EXPENSIVE_FIRST, NEWEST_FIRST, Z_A,
} from '../../constants';

const sortCarsArray = (cars, sortType) => {
  let payload;
  switch (sortType) {
    case A_Z: payload = Enumerable.from(cars).orderBy((el) => el.Car.Brand).toArray();
      break;
    case Z_A: payload = Enumerable.from(cars)
      .orderByDescending((el) => el.Car.Brand).toArray();
      break;
    case CHEAP_FIRST: payload = Enumerable.from(cars).orderBy((el) => el.Car.Price).toArray();
      break;
    case EXPENSIVE_FIRST:
      payload = Enumerable.from(cars).orderByDescending((el) => el.Car.Price).toArray();
      break;
    case NEWEST_FIRST:
      payload = Enumerable.from(cars).orderByDescending((el) => el.Car.CreatedDate).toArray();
      break;
    default:
      payload = Enumerable.from(cars).orderByDescending((el) => el.Car.CreatedDate).toArray();
  }

  return { type: SORT_CARS_ARRAY, payload, sortType };
};

export default sortCarsArray;
